import MultiquoteDebugInsuranceCompany from './MultiquoteDebugInsuranceCompany'
import MultiquoteDebugLog from './MultiquoteDebugLog'

class MultiquoteDebugCompanyLogs {
    constructor(insuranceCompany, logs) {
        this.insuranceCompany = insuranceCompany
        this.logs = logs
    }

    static fromJson({ insuranceCompany, logs = [] } = {}) {
        return new MultiquoteDebugCompanyLogs(
            MultiquoteDebugInsuranceCompany.fromJson(insuranceCompany),
            logs.map((log) => MultiquoteDebugLog.fromJson(log))
        )
    }
}

export default MultiquoteDebugCompanyLogs
